<template>
    <div class="footer-widget mb-0">
        <h4 class="footer-widget__title">Social Media</h4>
        <div class="footer-widget__content">
            <div class="social-links social-links--white-topbar d-inline-block">
               <ul>
                    <li v-for="list in data" :key="list.id">
                        <a :href="list.link" :class="list.class" target="_blank"><i :class="list.icon"></i></a>
                    </li>
               </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    };
</script>